import UserType from 'constants/user';
import { UserQuizStatus } from 'containers/quiz_manager';
import { useAuth } from 'contexts/AuthContext';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from 'routes/constant';

export default function PrivateRoute({ component: Component, ...rest }) {
    const { currentUser } = useAuth();
    const approvedState = useSelector((state: RootState) => state.authentication.approved);
    const user = useSelector((state: RootState) => state.userDetail.me);
    const pendingQuizzes = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const isPendingQuizzes =
        pendingQuizzes?.hasOwnProperty('getPendingQuizzes') &&
        pendingQuizzes?.getPendingQuizzes?.quizConfigs?.filter((item) => item.status === UserQuizStatus.pending)
            ?.length;
    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;

                return currentUser ? (
                    approvedState && user?.userType === UserType.Stylist ? (
                        <Component {...props} />
                    ) : approvedState && user?.userType === UserType.Customer ? (
                        isPendingQuizzes === 0 ? (
                            <Component {...props} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: PATH.QUIZ_MANAGER,
                                    state: { from: location },
                                }}
                            />
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: PATH.HOME_WAITING,
                                state: { from: location },
                            }}
                        />
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: PATH.LOGIN,
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
